<template>
  <ConfirmDialog></ConfirmDialog>
  <Toast />

  <div class="flex align-items-center gap-2 text-sm text-500 mb-2 px-1">
    <span class="font-semibold">Ventas</span>
    <i class="pi pi-angle-right text-xs"></i>
    <span>Listado de Ventas</span>
  </div>

  <div class="surface-card shadow-1 border-round p-2">
    <div
      class="flex flex-wrap align-items-center justify-content-between mb-2 gap-2"
    >
      <div class="flex align-items-center gap-2">
        <span class="text-lg font-bold text-900">Administrar Ventas</span>
        <Badge size="xlarge" severity="success">{{ totalRecords }}</Badge>
      </div>
      <div class="flex gap-2">
        <Button
          icon="pi pi-refresh"
          class="p-button-info p-button-outlined"
          v-tooltip.top="'Actualizar'"
          @click="cargarVentas"
        />
        <Button
          v-if="'Venta Crear' in auth.user.permissions"
          label="Nueva Venta"
          icon="pi pi-plus"
          class="p-button-info p-button-lg"
          @click="nuevaVenta"
        />
      </div>
    </div>

    <!-- Filtros -->
    <div
      class="surface-100 p-2 border-round mb-2 border-1 surface-border flex gap-2 align-items-end flex-wrap"
    >
      <div class="flex-2" style="min-width: 150px">
        <strong>CÓDIGO:</strong>
        <InputNumber
          v-model="filtros.codigo"
          :useGrouping="false"
          class="w-full"
          @keyup.enter="buscarVentas"
        />
      </div>
      <div class="flex-1" style="min-width: 250px">
        <span v-if="this.tipo_negocio == 2"
          ><strong>BUSCAR POR PLACA | CLIENTE:</strong></span
        >
        <span v-else><strong>BUSCAR POR CLIENTE | NIT/CI:</strong></span>
        <div class="p-input-icon-right w-full">
          <InputText
            v-model="filtros.buscar"
            class="w-full"
            placeholder="Buscar..."
            @keyup.enter="buscarVentas"
          />
          <i class="pi pi-search" @click="buscarVentas" />
        </div>
      </div>
      <div>
        <Button
          icon="pi pi-search"
          label="BUSCAR"
          class="p-button-primary p-button-lg p-button-outlined"
          @click="buscarVentas"
        />
      </div>
    </div>

    <!-- DataTable -->
    <DataTable
      ref="ventas"
      :value="ventas"
      dataKey="id"
      :lazy="true"
      :paginator="true"
      :rows="lazyParams.rows"
      :totalRecords="totalRecords"
      :loading="cargando"
      @page="onPage"
      class="p-datatable-sm"
      selectionMode="single click"
      :rowsPerPageOptions="[15, 50, 100, 500]"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
      currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} Ventas"
      responsiveLayout="scroll"
      showGridlines
      stripedRows
      v-model:expandedRows="expandedRows"
    >
      <!-- HEADER CON BOTONES EXPANDIR/CONTRAER -->
      <template #header v-if="'Producto Actualizar' in auth.user.permissions">
        <div class="flex flex-wrap justify-content-end gap-2">
          <Button
            icon="pi pi-minus"
            label="Colapsar Todo"
            class="p-button-info p-button-sm"
            @click="collapseAll"
          />
          <Button
            icon="pi pi-plus"
            label="Expandir Todo"
            class="p-button-info p-button-sm"
            @click="expandAll"
          />
        </div>
      </template>

      <!-- EXPANSION: CARGAR PRODUCTOS DINÁMICAMENTE -->
      <template
        #expansion="slotProps"
        v-if="'Producto Actualizar' in auth.user.permissions"
      >
        <div class="p-3">
          <h5>
            <span style="border-bottom: 1px solid #ccc">
              DETALLE DE VENTA:
              <strong
                >{{ slotProps.data.id }} -
                {{ slotProps.data.razon_social }}</strong
              >
            </span>
          </h5>

          <!-- LOADING MIENTRAS CARGA PRODUCTOS -->
          <div v-if="!slotProps.data.productos" class="text-center p-4">
            <ProgressSpinner style="width: 30px; height: 30px" />
            <p class="mt-2">Cargando productos...</p>
          </div>

          <!-- TABLA DE PRODUCTOS -->
          <DataTable
            v-else
            :value="slotProps.data.productos"
            class="p-datatable-sm"
            responsiveLayout="scroll"
            stripedRows
            showGridlines
            @row-dblclick="editarProducto($event.data)"
          >
            <Column field="id" header="COD_PROD" class="text-right"></Column>
            <Column
              field="descripcion"
              header="PRODUCTO/DESCRIPCIÓN"
              style="min-width: 250px; font-weight: bold"
            >
              <template #body="slotProps">
                <div>
                  <span>{{ slotProps.data.descripcion }}</span>
                  <span
                    class="ml-2"
                    v-if="slotProps.data.nombre_medico"
                    style="
                      font-size: 11px;
                      background-color: #e0e0e0;
                      padding: 2px;
                      border-radius: 3px;
                    "
                    v-tooltip.top="
                      `Trabajador: ${slotProps.data.nombre_medico}`
                    "
                  >
                    <i class="pi pi-user" style="color: #2196f3"></i>
                    {{ slotProps.data.nombre_medico }}
                  </span>
                </div>
              </template>
            </Column>
            <Column header="CANTIDAD" class="text-right">
              <template #body="{ data }">
                {{ data.pivot?.cantidad ?? data.cantidad }}
              </template>
            </Column>
            <Column header="PRECIO" class="text-right">
              <template #body="{ data }">
                {{
                  convertirNumeroGermanicFormat(
                    data.pivot?.precio ?? data.precio,
                  )
                }}
              </template>
            </Column>
            <Column header="SUBTOTAL" class="text-right">
              <template #body="{ data }">
                {{
                  convertirNumeroGermanicFormat(
                    (data.pivot?.cantidad ?? data.cantidad) *
                      (data.pivot?.precio ?? data.precio),
                  )
                }}
              </template>
            </Column>
            <Column header="DESCUENTO" class="text-right">
              <template #body="{ data }">
                {{
                  convertirNumeroGermanicFormat(
                    data.pivot?.descuento_neto ?? data.descuento_neto ?? 0,
                  )
                }}
              </template>
            </Column>
            <Column header="TOTAL" class="text-right">
              <template #body="{ data }">
                {{
                  convertirNumeroGermanicFormat(
                    (data.pivot?.cantidad ?? data.cantidad) *
                      (data.pivot?.precio ?? data.precio) -
                      (data.pivot?.descuento_neto ?? data.descuento_neto ?? 0),
                  )
                }}
              </template>
            </Column>
          </DataTable>
        </div>
      </template>

      <template #loading>
        <div class="flex align-items-center justify-content-center">
          <ProgressSpinner />
        </div>
      </template>

      <template #empty>
        <div class="text-center p-4 text-sm">No existen Registros!</div>
      </template>

      <Column
        expander
        style="width: 2rem"
        v-if="'Producto Actualizar' in auth.user.permissions"
      ></Column>

      <Column
        field="id"
        header="NRO"
        class="text-right"
        style="font-weight: bold"
      ></Column>

      <Column field="nombre_usuario_caja" header="VENDEDOR"></Column>

      <Column field="razon_social" header="RAZÓN SOCIAL">
        <template #body="{ data }">
          <span v-if="tipo_negocio == 2">
            <span>{{ data.razon_social }}</span>
            <strong> - Placa: </strong>
            <span>{{ data.placa_vehiculo ?? "-" }}</span>
          </span>
          <span v-else>
            {{ data.razon_social }}
          </span>
        </template>
      </Column>

      <Column field="nit" header="NIT/CI">
        <template #body="{ data }">
          <div class="nit-container">
            <span>{{ data.nit || "S/N" }}</span>
            <i
              v-if="
                data.razon_social && data.razon_social !== data.nombre_cliente
              "
              class="pi pi-info-circle info-icon"
              v-tooltip.top="data.razon_social"
            ></i>
          </div>
        </template>
      </Column>

      <Column header="F.VENTA" class="text-center">
        <template #body="{ data }">
          <div class="fecha-container">
            {{ formatDate(data.fecha_venta) }}
            {{ formatTime(data.fecha_venta) }}
          </div>
        </template>
      </Column>

      <Column
        v-if="hasDescuentos"
        field="descuento"
        header="DESC."
        class="text-right"
      >
        <template #body="{ data }">
          <span v-if="data.descuento > 0" class="descuento-badge">
            -{{ convertirNumeroGermanicFormat(data.descuento) }}
          </span>
          <span v-else class="text-400"></span>
        </template>
      </Column>

      <Column
        field="total_cancelar"
        header="T.VENTA"
        class="text-right"
        style="font-weight: bold"
        v-if="'Caja Ver Detalle' in auth.user.permissions"
      >
        <template #body="{ data }">
          <span class="monto-total">{{
            convertirNumeroGermanicFormat(data.total_cancelar)
          }}</span>
        </template>
      </Column>

      <Column
        field="calculo_efectivo"
        header="EFECTIVO"
        class="text-right"
        v-if="'Caja Ver Detalle' in auth.user.permissions"
      >
        <template #body="{ data }">
          <span class="monto-efectivo">{{
            convertirNumeroGermanicFormat(data.calculo_efectivo)
          }}</span>
        </template>
      </Column>

      <!-- COLUMNA QR - SOLO SE MUESTRA SI HAY MONTOS EN LAS VENTAS -->
      <Column
        field="total_venta_qr"
        header="QR"
        class="text-right"
        v-if="'Caja Ver Detalle' in auth.user.permissions && hasQR"
      >
        <template #body="{ data }">
          <span v-if="data.total_venta_qr > 0" class="monto-transferencia">
            {{ convertirNumeroGermanicFormat(data.total_venta_qr) }}
          </span>
        </template>
      </Column>

      <!-- COLUMNA TARJETA - SOLO SE MUESTRA SI HAY MONTOS EN LAS VENTAS -->
      <Column
        field="total_venta_tarjeta"
        header="TARJETA"
        class="text-right"
        v-if="'Caja Ver Detalle' in auth.user.permissions && hasTarjeta"
      >
        <template #body="{ data }">
          <span v-if="data.total_venta_tarjeta > 0" class="monto-transferencia">
            {{ convertirNumeroGermanicFormat(data.total_venta_tarjeta) }}
          </span>
        </template>
      </Column>

      <Column
        field="facturado"
        header="ENVIADO"
        class="text-center"
        v-if="'Venta Facturar' in auth.user.permissions"
      >
        <template #body="{ data }">
          <Tag
            :value="data.facturado === 1 ? 'SI' : 'NO'"
            :severity="data.facturado === 1 ? 'success' : 'danger'"
            class="tag-large"
          />
        </template>
      </Column>

      <Column
        v-if="'Venta FactIndicador' in auth.user.permissions"
        field="fact_indicador"
        header="FACTURA"
        class="text-center"
      >
        <template #body="{ data }">
          <Tag
            :value="data.fact_indicador === 1 ? 'SI' : 'NO'"
            :severity="data.fact_indicador === 1 ? 'success' : 'danger'"
            class="tag-large"
          />
        </template>
      </Column>

      <Column field="nombre_medico" header="REALIZÓ" v-if="tipo_negocio == 2">
        <template #body="{ data }">
          {{ data.nombre_medico ?? "-" }}
        </template>
      </Column>

      <Column header="ESTADO" class="text-center">
        <template #body="{ data }">
          <Tag
            :value="data.estado_texto"
            :severity="data.estado ? 'success' : 'danger'"
            class="tag-large"
          />
        </template>
      </Column>

      <Column header="ACCIONES" class="text-center">
        <template #body="slotProps">
          <Button
            icon="pi pi-ellipsis-v"
            class="p-button-icon-only p-button-raised p-button-info"
            v-tooltip.top="'Ver Acciones'"
            @click="$refs['menu' + slotProps.data.id].toggle($event)"
          />
          <Menu
            :ref="'menu' + slotProps.data.id"
            :popup="true"
            :model="acciones(slotProps.data)"
          />
        </template>
      </Column>
    </DataTable>

    <Dialog
      v-model:visible="motivoAnulacionDialog"
      modal
      header="MOTIVO DE ANULACIÓN"
      :style="{ width: '450px' }"
    >
      <div class="p-fluid">
        <div class="field">
          <label for="motivo_anulacions" class="font-semibold mb-2">
            SELECCIONE MOTIVO DE ANULACIÓN:
          </label>
          <Dropdown
            id="motivo_anulacions"
            v-model="motivoAnulacionSelected"
            :options="motivo_anulacions"
            optionLabel="descripcion"
            optionValue="codigoClasificador"
            placeholder="Seleccione un motivo"
            class="w-full"
          />
        </div>
      </div>
      <template #footer>
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-text"
          @click="motivoAnulacionDialog = false"
        />
        <Button
          label="Anular Factura"
          icon="pi pi-trash"
          class="p-button-danger"
          :loading="enviando"
          @click="anularVentaFactura(anularVentaId)"
        />
      </template>
    </Dialog>
  </div>

  <VentaFacturar
    v-if="ventafacturaDialog"
    :show="ventafacturaDialog"
    :ventaFactura="ventaFactura"
    @closeModal="ocultarDialog"
    @actualizarListado="cargarVentas"
  />

  <VentaMetodoPago
    v-if="metodoPagoDialog"
    :show="metodoPagoDialog"
    :metodoPago="metodoPago"
    @closeModal="cerrarModalMetodoPago"
    @actualizarListado="cargarVentas"
  />
</template>

<script>
import VentaService from "@/service/VentaService";
import { useAuth } from "@/stores";
import VentaFacturar from "@/module/ventas/VentaFacturar.vue";
import VentaMetodoPago from "@/module/ventas/VentaMetodoPago.vue";

export default {
  components: {
    VentaFacturar,
    VentaMetodoPago,
  },
  data() {
    return {
      ventas: [],
      totalRecords: 0,
      cargando: false,
      lazyParams: {
        page: 1,
        rows: 15,
      },
      filtros: {
        codigo: null,
        buscar: "",
      },
      qr: "",
      mostrar_qr: false,
      ventaFactura: {},
      ventafacturaDialog: false,
      metodoPagoDialog: false,
      metodoPago: {},
      motivo_anulacions: [],
      motivoAnulacionSelected: null,
      motivoAnulacionDialog: false,
      anularVentaId: null,
      enviando: false,
      expandedRows: [],
      mostrarProductoModal: false,
      producto: {},
      tipo_negocio: null,
    };
  },
  auth: null,
  created() {
    this.auth = useAuth();
    this.ventaService = new VentaService();
  },
  mounted() {
    this.cargarVentas();
  },
  computed: {
    hasDescuentos() {
      return this.ventas.some((v) => parseFloat(v.descuento) > 0);
    },
    hasQR() {
      return this.ventas.some((v) => parseFloat(v.total_venta_qr) > 0);
    },
    hasTarjeta() {
      return this.ventas.some((v) => parseFloat(v.total_venta_tarjeta) > 0);
    },
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },

    formatTime(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${hours}:${minutes}`;
    },

    convertirNumeroGermanicFormat(numero) {
      if (!numero && numero !== 0) return "0.00";
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(parseFloat(numero));
    },

    cargarMotivoAnulacion() {
      if (this.motivo_anulacions.length > 0) return;
      this.ventaService.motivo_anulacions().then((data) => {
        this.motivo_anulacions = data.motivo_anulacions || [];
        this.motivoAnulacionSelected =
          this.motivo_anulacions[0]?.codigoClasificador || null;
      });
    },

    motivoAnulacionDialogConfirm(datos) {
      this.anularVentaId = datos.id;
      this.motivoAnulacionDialog = true;
      this.enviando = false;
      this.cargarMotivoAnulacion();
    },

    cargarVentas() {
      this.cargando = true;

      const params = {
        page: this.lazyParams.page,
        per_page: this.lazyParams.rows,
        tipo_negocio: this.tipo_negocio,
        ...this.filtros,
      };

      Object.keys(params).forEach((key) => {
        if (
          params[key] === null ||
          params[key] === "" ||
          params[key] === undefined
        ) {
          delete params[key];
        }
      });

      if (params.codigo) {
        params.codigo = parseInt(params.codigo);
      }

      this.ventaService
        .getVentasPaginadas(params)
        .then((response) => {
          if (response && response.data) {
            this.ventas = response.data;
            this.totalRecords = response.total || response.data.length;

            if (this.ventas.length > 0 && this.ventas[0].caja) {
              this.tipo_negocio = this.ventas[0].caja.tipo_negocio || 1;
            }
            this.ventas = this.ventas.map((venta) => ({
              ...venta,
              estado_texto:
                venta.estado_texto || (venta.estado ? "VÁLIDO" : "ANULADO"),
              productos: null,
            }));
          } else {
            this.ventas = [];
            this.totalRecords = 0;
          }
          this.cargando = false;
        })
        .catch((error) => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error al cargar las ventas: " + error.message,
            life: 3000,
          });
          this.ventas = [];
          this.totalRecords = 0;
          this.cargando = false;
        });
    },

    onPage(event) {
      this.lazyParams.page = event.page + 1;
      this.lazyParams.rows = event.rows;
      this.cargarVentas();
    },

    buscarVentas() {
      this.lazyParams.page = 1;
      this.cargarVentas();
    },

    editarProducto(datos) {
      this.producto = { ...datos };
      this.producto.estado = { label: datos.estado_texto, value: datos.estado };
      this.producto.stock_minimo = parseInt(this.producto.stock_minimo || 0);
      this.producto.stock_maximo = parseInt(this.producto.stock_maximo || 0);
      this.producto.precio_sugerido = parseFloat(
        this.producto.precio_sugerido || 0,
      );
      this.producto.precio_compra = parseFloat(
        this.producto.precio_compra || 0,
      );
      this.producto.stock_actual = parseInt(this.producto.stock_actual || 0);
      this.producto.tipo_catalogo = parseInt(this.producto.tipo_catalogo || 1);
      this.mostrarProductoModal = true;
    },

    cerrarModal() {
      this.mostrarProductoModal = false;
      this.producto = {};
    },

    expandAll() {
      this.expandedRows = this.ventas.filter((p) => p.id);
    },

    collapseAll() {
      this.expandedRows = [];
    },

    acciones(datos) {
      return [
        {
          label: "Ver Detalle",
          icon: "pi pi-fw pi-eye",
          disabled: !("Venta Ver Detalle" in this.auth.user.permissions),
          to: `/ventas/${datos.id}/detalle`,
        },
        {
          label: "Descargar PDF",
          disabled: !("Venta DescargarPDF" in this.auth.user.permissions),
          icon: "pi pi-fw pi-file-pdf",
          command: () => this.imprimirVenta(datos.id),
        },
        {
          label: "Crear Factura",
          disabled:
            datos.estado == 0 ||
            !("Venta Facturar" in this.auth.user.permissions),
          icon: "pi pi-fw pi-file",
          visible: datos.facturado == 0,
          command: () => this.ventaFacturar(datos),
        },
        {
          label: "Anular Venta",
          icon: "pi pi-fw pi-trash",
          disabled:
            datos.estado == 0 ||
            !("Venta Anular" in this.auth.user.permissions),
          visible: datos.facturado != 1,
          command: () => this.anularVenta(datos.id),
        },
        {
          label: "Anular Factura",
          icon: "pi pi-fw pi-trash",
          disabled:
            datos.estado == 0 ||
            !("Venta Anular" in this.auth.user.permissions),
          visible: datos.facturado == 1,
          command: () => this.motivoAnulacionDialogConfirm(datos),
        },
        {
          label: "Cambiar Método de Pago",
          icon: "pi pi-fw pi-money-bill",
          disabled: datos.estado == 0,
          command: () => this.ventaMetodoPago(datos),
        },
      ];
    },

    ventaMetodoPago(datos) {
      this.metodoPago = { ...datos };
      this.metodoPagoDialog = true;
    },

    cerrarModalMetodoPago() {
      this.metodoPagoDialog = false;
    },

    ventaFacturar(venta) {
      this.ventaFactura = {
        ...venta,
        nit:
          venta.nit && venta.nit !== "0" && venta.nit !== "99001"
            ? Number(venta.nit)
            : null,
      };
      this.ventafacturaDialog = true;
    },

    ocultarDialog() {
      this.ventafacturaDialog = false;
    },

    anularVentaFactura(id) {
      this.cargarMotivoAnulacion();
      this.enviando = true;
      let datos = {
        id: id,
        motivoAnulacion: this.motivoAnulacionSelected,
      };
      this.ventaService
        .anularVenta(id, datos)
        .then((response) => {
          this.$toast.add({
            severity: response.status == 200 ? "success" : "error",
            summary: response.status == 200 ? "Éxito" : "Error",
            detail: response.mensaje || response.message,
            life: 3000,
          });
          if (response.status == 200) {
            this.cargarVentas();
            this.motivoAnulacionDialog = false;
          }
          this.enviando = false;
        })
        .catch(() => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error al anular la venta",
            life: 3000,
          });
          this.enviando = false;
        });
    },

    anularVenta(id) {
      this.$confirm.require({
        header: "CONFIRMACIÓN",
        message: "¿ESTÁS SEGURO DE ANULAR ESTA VENTA?",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí, Anular",
        rejectLabel: "No, Cancelar",
        acceptClass: "p-button-danger",
        rejectClass: "p-button-text",
        accept: () => {
          this.ventaService
            .anularVenta(id)
            .then((response) => {
              this.$toast.add({
                severity: response.status == 200 ? "success" : "error",
                summary: response.status == 200 ? "Éxito" : "Error",
                detail: response.mensaje || response.message,
                life: 3000,
              });
              if (response.status == 200) {
                this.cargarVentas();
              }
            })
            .catch(() => {
              this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: "Error al anular la venta",
                life: 3000,
              });
            });
        },
      });
    },

    nuevaVenta() {
      this.$router.push({ name: "nueva_venta" });
    },

    imprimirVenta(id) {
      this.ventaService
        .imprimirVenta(id)
        .then(() => {})
        .catch(() => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error al imprimir la venta",
            life: 3000,
          });
        });
    },
  },

  watch: {
    expandedRows(newVal) {
      if (newVal && newVal.length > 0) {
        newVal.forEach((venta) => {
          if (!venta.productos) {
            this.ventaService
              .obtenerProductosVenta(venta.id)
              .then((response) => {
                if (response.success) {
                  venta.productos = response.productos;
                  this.$forceUpdate();
                }
              })
              .catch((error) => {
                this.$toast.add({
                  severity: "error",
                  summary: "Error",
                  detail:
                    "No se pudieron cargar los productos: " + error.message,
                  life: 3000,
                });
              });
          }
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.nit-container {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  white-space: nowrap;
  font-weight: 500;
}

.info-icon {
  color: #0284c7;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;

  &:hover {
    color: #0369a1;
  }
}

.fecha-container {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  white-space: nowrap;
}

.monto-total {
  color: #0f172a;
  font-weight: 600;
  font-size: 1rem;
}

.monto-efectivo {
  color: #0f172a;
  font-weight: 500;
  font-size: 1rem;
}

.monto-transferencia {
  color: #0f172a;
  font-weight: 500;
  font-size: 1rem;
}

.descuento-badge {
  background: #fee2e2;
  color: #dc2626;
  padding: 4px 8px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 0.85rem;
  display: inline-block;
}

.tag-large {
  font-size: 0.9rem;
  font-weight: 600;
}
</style>
